import { useContext } from "react";

import { QuickRankStateContext } from "../../contexts/quickrank/state";

export const useQuickRankState = () => {
  const context = useContext(QuickRankStateContext);
  if (!context) {
    throw new Error("useQuickRankState must be used within a QuickRankContextProvider");
  }
  return context;
};
